'use client';

import { cn } from '@/app/utils';

interface HeroIndicatorProps {
  /** 每一项的稳定 key（如各视频的 name），长度即指示器条数。 */
  keys: string[];
  activeIndex: number;
  onSelect: (index: number) => void;
  className?: string;
}

/**
 * 首屏轮播指示器，参照 NIO 底部样式：一排细横条，当前项高亮加宽，其余暗淡。
 * 点击可跳转到对应视频。
 */
export const HeroIndicator = ({ keys, activeIndex, onSelect, className }: HeroIndicatorProps) => {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      {keys.map((key, index) => {
        const isActive = index === activeIndex;
        return (
          <button
            key={key}
            type="button"
            aria-label={`switch to slide ${index + 1}`}
            aria-current={isActive}
            onClick={() => onSelect(index)}
            className="group flex h-4 cursor-pointer items-center"
          >
            <span
              className={cn(
                'block h-[2px] rounded-full transition-all duration-300 ease-out',
                isActive ? 'w-12 bg-white' : 'w-8 bg-white/30 group-hover:bg-white/60',
              )}
            />
          </button>
        );
      })}
    </div>
  );
};
